import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import z from "zod";
import { DoorOpeningScreen } from "~/components/DoorOpeningScreen";
import { AppHeader } from "~/components/layout/AppHeader";

export const Route = createFileRoute("/one-delivery/opening")({
	beforeLoad: () => {
		document.title = "bacehub | One Delivery";
	},
	component: RouteComponent,
	validateSearch: zodValidator(z.object({ bundleId: z.string(), unlockRequestId: z.string() })),
});

function RouteComponent() {
	const navigate = useNavigate();
	const { bundleId, unlockRequestId } = Route.useSearch();
	return (
		<DoorOpeningScreen
			unlockRequestId={unlockRequestId}
			header={<AppHeader showHelpButton={true} />}
			onExit={() => navigate({ to: "/one-delivery/bundle/$bundleId", params: { bundleId } })}
			onOpened={() => navigate({ from: Route.fullPath, to: "/one-delivery/collect", search: { bundleId, unlockRequestId } })}
			onClosed={() => navigate({ from: Route.fullPath, to: "/one-delivery/finish", search: { bundleId } })}
		/>
	);
}
